import AllSports from './AllSports';

export default AllSports;
